import {createFileRoute} from "@tanstack/react-router"
import {InnerReferral} from "@/components/InnerReferral/InnerReferral.tsx";

export const Route = createFileRoute("/_mainLayout/inner-referral/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <InnerReferral />
  );
}
